import {Divider, Flex, Spacer, Text, VStack} from "@chakra-ui/react";
import React, {useEffect} from "react";
import {BsStar} from "react-icons/bs";
import Card from "components/card/Card"
import {platformToPlatformName} from "variables/constants";

const monthToText = {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December"
}

// TODO: The below is bad and it should be replaced with reading the platform_name from the DB or changing the api response to include that


export default function SearchResultsList({searchResults, error, brandFilter, platformFilter, setResultsLength}) {
    let reviews = []
    let filtered = []
    useEffect(() => {
        if (reviews) {
            setResultsLength(reviews.length)
        }
    }, [reviews])
    if (searchResults.length === 0) {
        reviews = <Text>No reviews found</Text>
    } else if (error) {
        reviews = <Text>Error getting search results - {error.message}</Text>
    } else if (brandFilter.length === 0) {
        reviews = <Text>Please select atleast one brand above to see search results</Text>
    } else {
        filtered = searchResults.filter(review => brandFilter.includes(review.brand))
        filtered = filtered.filter(review => platformFilter.includes(review.platform))

        reviews = filtered.map((t, index) => {
            const d = new Date(t.timestamp);

            return <Flex key={index} direction="column" bgColor="#EEEEEE" minHeight="42px" borderRadius="10px"
                         w="700px"
            >
                <Flex direction="row" alignItems="center" verticalAlign="bottom" px="6px" borderRadius="10px">
                    <Text fontWeight="bold">{t.data.product_name}</Text>
                    <Spacer/>
                    <BsStar/>
                    <Text
                        fontWeight="bold">{t.data.review_rating + ' '}</Text>

                    <Text>{' — ' + platformToPlatformName[t.platform] ?? ""}</Text>
                    <Text>{' — ' + d.getDate() + ' ' + monthToText[d.getMonth()] + ' ' + d.getFullYear()}</Text>
                </Flex>
                <Divider bgColor="rgba(0,0,0,0.45)" h="2px"/>
                <Text mx="5px">{t.text}</Text>

            </Flex>
        })
    }

    return (
        <Card w="100%">
            <VStack spacing={2} mt="10px"
                    align="stretch">
                {reviews}
            </VStack>
        </Card>
    )
}